module.exports = __webpack_public_path__ + "img/存储设备定位追回系统V1.0.c8952a50.jpg";